'use strict';

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

// Import the CSS
import '../../scss/components/_error-page.scss';

const errorMessages = {
	401: 'Sorry, you are not logged in.',
	403: 'Sorry, you do not have permission to access this page.',
	404: "Sorry, we can't find the page you're looking for.",
};

class ErrorPage  extends Component {

	render () {
		const errorCode = this.props.route.errorCode;

		return (
			<div id="error-page">
				<div id="error-code">{errorCode}</div>
				<div id="tool-row">
					<div id="tool-image"/>
				</div>
				<div id="sorry-message">{errorMessages[errorCode]}</div>
				<If condition={ errorCode === 404 }>
					<If condition={ this.props.user.isLoggedIn() } >
						<div id="links">
							<If condition={ this.props.user.can('full-data-browsing') }>
								<Link to="/corporations">Corporations</Link>
							</If>
							<If condition={ this.props.user.can('view-feed-list') }>
								<Link to="/feeds">Feeds</Link>
							</If>
						</div>
					</If>
				</If>
			</div>
		);
	}

}

ErrorPage.propTypes = {
	route: PropTypes.shape({
		errorCode: PropTypes.string.isRequired,
	}).isRequired,
	user: PropTypes.shape({
		isLoggedIn: PropTypes.function,
		can: PropTypes.function,
	})
};

export default connect(
	state => {
		return {
			user: state.auth.user,
		};
	})(ErrorPage);



// WEBPACK FOOTER //
// ./src/assets/js/components/ErrorPage.js